import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useGetChatSettingsAllProperties } from "./useGetChatSettingsAllProperties";
import ListItemsSelectNavigationContainer from "@/components/layouts/ListItemsSelectNavigationContainer/ListItemsSelectNavigationContainer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSettingsAll',
  setup(__props) {

const { chatSettingsAllProperties } = useGetChatSettingsAllProperties();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsSelectNavigationContainer, _normalizeProps(_guardReactiveProps(_unref(chatSettingsAllProperties))), null, 16))
}
}

})